import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-first-name-salutation',
  templateUrl: './first-name-salutation.component.html',
  styleUrls: ['./first-name-salutation.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FirstNameSalutationComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FirstNameSalutationComponent),
      multi: true,
    },
  ],
})
export class FirstNameSalutationComponent implements OnInit, ControlValueAccessor, Validator {
  // TODO: replate with LOV
  salutations: any = [
    { key: 'Mr', name: 'Mr' },
    { key: 'Mrs', name: 'Mrs' },
    { key: 'Miss', name: 'Miss' },
    { key: 'Dr', name: 'Dr' }
  ];

  @Input() maxLength: any = 50;

  value: { salutation: string | null; firstName: string } = { salutation: null, firstName: '' };

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  @Input() isDisabled:boolean = false;

  constructor() {}

  ngOnInit() {}

  // ControlValueAccessor methods
  writeValue(value: any): void {
    if (value) {
      this.value = {
        salutation: value.salutation || null,
        firstName: value.firstName,
      };
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle disabling the component if needed
    this.isDisabled = isDisabled;
  }

  onValueChange(): void {
    this.onChange(this.value);
    this.onTouched();
  }

  // Validator method
  validate(control: AbstractControl): ValidationErrors | null {
    const { salutation, firstName } = this.value;
    if (!firstName) {
      return { required: 'first name is required' };
    }
    return null;
  }
}
